module.exports = __webpack_public_path__ + "img/Preparing_the_Area.40672d20.png";